import {
  formatearMontoPesosConDefault,
} from "../../../utils/CurrencyUtil";

export const PRECERTIFICACION_WARNING = {
  CONFIRMAR:
    "Es imprescindible confirmar la precertificación, en caso contrario no podrá realizar el reclamo.",
  CANCELAR: "Al cancelar la precertificación no se puede volver a activar.",
};

export const ESTADO_PRECERTIFICACION = {
  VIGENTE: "VIGENTE",
  CANCELADA: "CANCELADA",
  CONVERTIDA: "CONVERTIDA",
};

export const getMontoField = (record) => {
  return record.montoAsegurado ?? record.montoAfiliado ?? record.montoDiferencia ?? 0;
};

export const getMontoTitle = (record) => {
  if (record.montoAsegurado !== undefined && record.montoAsegurado !== null) {
    return "Asegurado";
  } else if (record.montoAfiliado !== undefined && record.montoAfiliado !== null) {
    return "Afiliado";
  } else if (record.montoDiferencia !== undefined && record.montoDiferencia !== null) {
    return "Diferencia";
  }
  return "Diferencia";
};

export const columnsDetallePrecertificacion = (empresa) => {
  return [
    {
      key: "nombre",
      title: "Examen",
      dataIndex: "nombre",
    },
    {
      key: "codigo",
      title: "Código",
      dataIndex: "codigo",
    },
    {
      key: "frecuencia",
      title: "Frecuencia",
      dataIndex: "frecuencia",
    },
    {
      key: "montoReclamado",
      title: "Reclamado",
      dataIndex: "montoReclamado",
      render: (text) => formatearMontoPesosConDefault(String(text)),
    },
    {
      key: "montoARS",
      title: "ARS",
      dataIndex: "montoARS",
      render: (text) => formatearMontoPesosConDefault(String(text)),
    },
    {
      key: "montoDiferencia",
      title: empresa?.TIPO_CLIENTE,
      dataIndex: "montoDiferencia",
      render: (text, record) => {
        const monto = getMontoField(record);
        return formatearMontoPesosConDefault(String(monto));
      },
    },
  ];
};

export const columnsDetallePrecertificacionAutorizada = () => {
  return [
    {
      key: "nombre",
      title: "Examen",
      dataIndex: "nombre",
      render: (text, record) => `(${record.key}) ${text}`,
    },
    {
      key: "cantidad",
      title: "Cantidad",
      dataIndex: "cantidad",
    },
    {
      key: "montoReclamado",
      title: "Reclamado",
      dataIndex: "montoReclamado",
      render: (text) => formatearMontoPesosConDefault(String(text)),
    },
    {
      key: "montoAutorizado",
      title: "Monto Autorizado",
      dataIndex: "montoAutorizado",
      render: (text) => formatearMontoPesosConDefault(String(text)),
    },
    {
      key: "montoDiferencia",
      title: "Diferencia",
      dataIndex: "montoDiferencia",
      render: (text, record) => {
        const monto = getMontoField(record);
        return formatearMontoPesosConDefault(String(monto));
      },
    },
  ];
};

export const columnsDetallePrecertificacionAutorizadaMadre = () => {
  // console.log("columnsDetallePrecertificacionAutorizadaMadre");
  return [
    {
      key: "nombre",
      title: "Procedimiento",
      dataIndex: "nombre",
    },
    {
      key: "key",
      title: "Código",
      dataIndex: "key",
    },
    {
      key: "cantidad",
      title: "Cantidad",
      dataIndex: "cantidad",
    },
    {
      key: "montoReclamado",
      title: "Monto Reclamado",
      dataIndex: "montoReclamado",
      render: (text) => formatearMontoPesosConDefault(String(text)),
    },
    {
      key: "montoAutorizacionPrimera",
      title: "ARS Primera",
      dataIndex: "montoAutorizacionPrimera",
      render: (text) => formatearMontoPesosConDefault(String(text)),
    },
    {
      key: "montoAutorizacionHumano",
      title: "Humano Seguros",
      dataIndex: "montoAutorizacionHumano",
      render: (text) => formatearMontoPesosConDefault(String(text)),
    },
    {
      key: "montoAutorizado",
      title: "Total Autorizado",
      dataIndex: "montoAutorizado",
      render: (text) => formatearMontoPesosConDefault(String(text)),
    },
    {
      key: "montoDiferencia",
      title: "Diferencia",
      dataIndex: "montoDiferencia",
      render: (text, record) => {
        const monto = getMontoField(record);
        return formatearMontoPesosConDefault(String(monto));
      },
    },
  ];
};

export const getFooterPosition = (showDetail) => {
  return showDetail ? "relative" : "fixed";
};

export const getFooterWidth = (showDetail) => {
  return showDetail ? "auto" : "100%";
};
